import { msg } from "@lingui/core/macro";
import { Show } from "solid-js";
import { Eye, LogOut } from "@fleet/icons";
import { showToast } from "@/components/ui/toast";
import { useI18n } from "@/providers/i18n-provider";
import { stopImpersonation, useImpersonation } from "../impersonation";

/**
 * F2-C — persistent top bar shown while impersonating ("ver como alumno").
 *
 * "Viendo como <name> — salir". Mounted once in the app shell; renders nothing
 * unless an impersonation overlay is active. "Salir" drops the token and returns
 * the admin to their own identity.
 */
export function ImpersonationBanner() {
  const { t } = useI18n();
  const { entry, isImpersonating } = useImpersonation();

  const exit = () => {
    void (async () => {
      const name = entry()?.impersonation?.targetName ?? "";
      await stopImpersonation();
      showToast(t(msg`Impersonation ended`), "success");
      // Hard reload keeps the app state clean (drops any target-scoped caches).
      globalThis.location.reload();
      void name;
    })();
  };

  return (
    <Show when={isImpersonating()}>
      <div
        data-testid="impersonation-banner"
        role="alert"
        class="flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-semibold text-black"
      >
        <Eye class="h-4 w-4 shrink-0" />
        <span class="truncate">
          {(() => {
            const name = entry()?.impersonation?.targetName ?? "";
            return t(msg`Viewing as ${name}`);
          })()}
        </span>
        <button
          type="button"
          data-testid="impersonation-exit"
          onClick={exit}
          class="inline-flex items-center gap-1.5 rounded-md bg-black/15 px-2.5 py-1 font-bold transition-colors hover:bg-black/25"
        >
          <LogOut class="h-3.5 w-3.5" />
          {t(msg`Exit`)}
        </button>
      </div>
    </Show>
  );
}
